import { render, staticRenderFns } from "./CardBeta.vue?vue&type=template&id=67d20f36&scoped=true&"
import script from "./CardBeta.vue?vue&type=script&lang=js&"
export * from "./CardBeta.vue?vue&type=script&lang=js&"
import style0 from "./CardBeta.vue?vue&type=style&index=0&id=67d20f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20f36",
  null
  
)

export default component.exports